import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

import { useModalControls } from 'src/js/hook/use-modal-controls';
import { SettingsTabContent } from 'src/js/pages/settings/settings-tab-content';
import { LicenseDeleteModal } from './license-delete-modal';
import { LicenseFeatures } from './license-features';
import { LicenseImportModal } from './license-import-modal';
import { fetchLicenses } from './license-store';
import { LicenseTable } from './license-table';
import { LicenseViewModel } from './license-view-model';
import { createListStore, ListSelector } from 'src/js/util/listSelector';
import { useMutable } from 'src/js/hook/use-mutable';
import { triggerEvent } from 'src/js/events';
import { RebootNeeded, RebootNeededRef } from 'src/js/reboot/reboot-needed';

export let licensesList: ListSelector<LicenseViewModel> = null;

export const Licenses: React.FunctionComponent = () => {
  const { t } = useTranslation();

  const [licenses, setLicenses] = useState([]);
  let listController: ListSelector<LicenseViewModel> = null;
  const [uuid] = useMutable(uuidv4());
  licensesList = listController = createListStore(licenses, uuid(), 'name');
  const [singleItem, setSingleItem] = useState<LicenseViewModel>();

  const [loading, setLoading] = useState(true);
  const fetchData = () => {
    fetchLicenses().then((res: any) => {
      if (res.ok) {
        const response = res.data;
        if (response) {
          setLicenses(response.data); // TODO find a better method incorporated with listController
          listController.updateList(response.data);
        }
        setLoading(false);
      }
    });
  };

  // Load the data on mount
  useEffect(() => {
    fetchData();
    triggerEvent('licenses-fetched');
  }, []);

  const shouldReloadData = (): void => {
    listController.unselectAll();
    fetchData();
  };

  const [deleteShown, showDelete, hideDelete] = useModalControls();
  const onDeleteCompleted = (failed: boolean): void => {
    hideDelete();
    setSingleItem(undefined);
    shouldReloadData();
    if (!failed) {
      rebootNeededRef.current.show();
    }
  };

  const [importShown, showImport, hideImport] = useModalControls();
  const handleImport = (): void => {
    hideImport();
    shouldReloadData();
    rebootNeededRef.current.show();
  };

  const rebootNeededRef = useRef<RebootNeededRef>(null);

  // console.log('render root license with list', listController.list);
  return (
    <>
      <SettingsTabContent name={t('settings.licensing.title')}>
        <LicenseTable
          listController={listController}
          onDelete={showDelete}
          showImport={showImport}
          loading={loading}
          setSingleItem={setSingleItem}
        />
        <LicenseFeatures />
      </SettingsTabContent>

      {deleteShown && (
        <LicenseDeleteModal
          licensesToDelete={singleItem ? [singleItem] : listController.selectedRows()}
          onCancel={() => {
            hideDelete();
            setSingleItem(undefined);
          }}
          onDeleteCompleted={onDeleteCompleted}
        />
      )}
      {importShown && <LicenseImportModal onCancel={hideImport} onImport={handleImport} />}

      <RebootNeeded ref={rebootNeededRef} />
    </>
  );
};
